const gridUnit = 4;
const boardWidth = 600;
const boardHeight = 284;
const iconSize = 35;
const holeHeight = 66;
const holeWidth = 82;
const toolbarHeight = 93;
const fontSize = gridUnit * 3;
const fontColor = "#333333";
const activeGreen = "#18af24";
const sowingDirection = "#515354c0";
const sowingDirectionDarker = "#515354f2";
const colors = {
  boardSide1: "#fde2e4",
  boardSide2: "#bee1e6",
  seedSide1: "#4e5d5c",
  seedSide2: "#4e5d5c",
  boardOrange: "#ef8d3982",
  boardGrey: "#525354",
  seedOrange: "#ef8d39",
  seedGrey: "#525354",
  activeColor: activeGreen,
  activeGreen,
  sowingDirection,
  sowingDirectionDarker,
  pink: "#fde2e4",
  grey0: "#555",
  grey1: "#666",
  grey2: "#777",
  grey3: "#888",
  grey4: "#999",
  grey5: "#aaa",
  grey6: "#bbb",
  grey7: "#ccc",
  grey8: "#ddd",
  grey9: "#eee",
  grey95: "#efefef",
  // Material Design colors
  primary: "#1976d2",
  primaryHover: "#1565c0",
  secondary: "#757575",
  secondaryHover: "#616161",
  buttonDefault: "#e0e0e0",
  buttonDefaultHover: "#bdbdbd",
  textPrimary: "#212121",
  textOnPrimary: "#ffffff",
  fontColor
};
const theme = {
  gridUnit,
  boardWidth,
  boardHeight,
  iconSize,
  toolbarHeight,
  holeHeight,
  holeWidth,
  seedRadius: gridUnit * 1.5,
  colors,
  fontSize,
  button: {
    borderRadius: gridUnit * 2,
    padding: gridUnit * 3,
    textDecoration: "none",
    background: colors.buttonDefault,
    color: colors.textPrimary,
    border: "none",
    cursor: "pointer",
    "&:hover": {
      background: colors.buttonDefaultHover,
      color: colors.textPrimary
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed"
    }
  },
  primaryButton: {
    borderRadius: gridUnit * 2,
    padding: gridUnit * 3,
    textDecoration: "none",
    background: colors.primary,
    color: colors.textOnPrimary,
    border: "none",
    cursor: "pointer",
    fontWeight: "500",
    "&:hover": {
      background: colors.primaryHover,
      color: colors.textOnPrimary
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed"
    }
  },
  secondaryButton: {
    borderRadius: gridUnit * 2,
    padding: gridUnit * 3,
    textDecoration: "none",
    background: colors.secondary,
    color: colors.textOnPrimary,
    border: "none",
    cursor: "pointer",
    "&:hover": {
      background: colors.secondaryHover,
      color: colors.textOnPrimary
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed"
    }
  }
};
type Theme = typeof theme;
export type { Theme };

declare module "@emotion/react" {
  export interface Theme {
    gridUnit: number;
    boardWidth: number;
    boardHeight: number;
    iconSize: number;
    toolbarHeight: number;
    holeHeight: number;
    holeWidth: number;
    seedRadius: number;
    colors: typeof colors;
    fontSize: number;
    button: typeof theme.button;
    primaryButton: typeof theme.primaryButton;
    secondaryButton: typeof theme.secondaryButton;
  }
}

export default theme;
